import React, { useState, useEffect, useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const AnimatedCounter = ({ end, duration = 2, suffix = "", className = "", decimals = 0 }) => {
    const [count, setCount] = useState(0);
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: "-50px" });

    useEffect(() => {
        if (!isInView) return;

        let startTime;
        let animationFrame;

        const animate = (timestamp) => {
            if (!startTime) startTime = timestamp;
            const progress = Math.min((timestamp - startTime) / (duration * 300), 1);

            // Easing function for smooth animation
            const easeOutQuad = 1 - Math.pow(1 - progress, 2);

            if (decimals > 0) {
                setCount((easeOutQuad * end).toFixed(decimals));
            } else {
                setCount(Math.round(easeOutQuad * end));
            }

            if (progress < 1) {
                animationFrame = requestAnimationFrame(animate);
            }
        };

        animationFrame = requestAnimationFrame(animate);

        return () => {
            if (animationFrame) {
                cancelAnimationFrame(animationFrame);
            }
        };
    }, [end, duration, isInView, decimals]);

    return (
        <motion.span
            ref={ref}
            className={className}
            initial={{ scale: 0.5, opacity: 0 }}
            animate={isInView ? { scale: 1, opacity: 1 } : {}}
            transition={{
                type: "spring",
                stiffness: 200,
                damping: 15,
                delay: 0.2
            }}
        >
            {count}{suffix}
        </motion.span>
    );
};

export default AnimatedCounter;